<template>
  <div>
    <div style="margin-top: 30px;display: block;display: flex;justify-content: space-between;">
      <!-- 企业1 个体0 -->
      <span>股东及授权办理人信息：</span>
      <el-button type="primary" size="small" style="font-size:20px" @click="add">+</el-button>
    </div>
    <el-divider />
    <el-form ref="infoForm" label-width="180px" v-for="(item, index) in holdList" :key="'list1-'+index">
        <div class="delet">
          <span>控股股东：</span>
          <el-button class="add" type="primary"  v-if="index !== 0" @click="holdListdeletInfo(item, index)" size="mini">删除</el-button>
        </div>
        <el-form-item label="股东身份证正面照：" prop="corporationIdCardUrlFront" v-if="item.shareCredType === '00'" style="display: none;">
          <el-upload
            ref="idCardForm"
            style="display:inline-block;margin-right:15px;"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :limit="1"
            list-type="picture-card"
            :on-remove="(file) => {frontHandleRemove(file)}"
            :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="股东身份证反面照：" prop="corporationIdCardUrlBack" v-if="item.shareCredType === '00'" style="display: none;">
          <el-upload
            ref="idCardForm"
            class="upload-demo"
            style="display:inline-block;margin-right:15px;"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :limit="1"
            list-type="picture-card"
            :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
            :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="上传证件：" prop="backUrl" v-if="item.shareCredType !== '00'" style="display: none;">
          <el-upload
            ref="uploadPersonal"
            style="display:inline-block;margin-right:15px;"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :limit="1"
            list-type="picture-card"
            :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
            :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名：" prop="shareName">
          <el-input v-model="item.shareName" style="width:340px" />
        </el-form-item>
        <el-form-item label="证件类型：" prop="shareCredType">
          <el-select v-model="item.shareCredType" placeholder="请选择">
            <el-option
              v-for="item in shareCredTypelist"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码：" prop="shareCredNo" style="width:540px">
          <el-input v-model="item.shareCredNo" />
        </el-form-item>
        <el-form-item label="证件有效期：">
          <div style="display: flex;align-items: center;width: 320px">
            <el-date-picker
              v-model="item.shareCredValidStart"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              placeholder="开始时间">
            </el-date-picker>
            至
            <el-date-picker
              v-model="item.shareCredValidEnd"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              placeholder="结束时间">
            </el-date-picker>
          </div>
      </el-form-item>
      <el-divider />
    </el-form>
    <el-form ref="infoForm" v-for="(item, index) in actualList" label-width="180px"  :key="'list2-'+index">
      <div class="delet">
        <span>实际控制人：</span>
        <el-button class="add" type="primary"  v-if="index !== 0" @click="actualdeletInfo(item, index)" size="mini">删除</el-button>
      </div>
      <el-form-item label="实控人身份证正面照：" prop="corporationIdCardUrlFront"  v-if="item.shareCredType === '00'" style="display: none;">
        <el-upload
          ref="idCardForm"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {frontHandleRemove(file)}"
          :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="实控人身份证反面照：" prop="corporationIdCardUrlBack"  v-if="item.shareCredType === '00'" style="display: none;">
        <el-upload
          ref="idCardForm"
          class="upload-demo"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
          :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="上传证件：" prop="backUrl" v-if="item.shareCredType !== '00'" style="display: none;">
        <el-upload
          ref="uploadPersonal"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
          :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="姓名：" prop="shareName">
        <el-input v-model="item.shareName" style="width:340px" />
      </el-form-item>
      <el-form-item label="证件类型：" prop="shareCredType">
        <el-select v-model="item.shareCredType" placeholder="请选择">
          <el-option
            v-for="item in shareCredTypelist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码：" prop="shareCredNo" style="width:540px">
        <el-input v-model="item.shareCredNo" />
      </el-form-item>
      <el-form-item label="证件有效期：">
        <div style="display: flex;align-items: center;width: 320px">
          <el-date-picker
            v-model="item.shareCredValidStart"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="开始时间">
          </el-date-picker>
          至
          <el-date-picker
            v-model="item.shareCredValidEnd"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="结束时间">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-divider />
    </el-form>
    <el-form ref="infoForm" v-for="(item, index) in grantList" label-width="180px" :key="'list3-'+index">
      <div class="delet">
        <span>授权办理人：</span>
        <el-button class="add" type="primary"  v-if="index !== 0" @click="grantdeletInfo(item, index)" size="mini">删除</el-button>
      </div>
      <el-form-item label="办理人身份证正面照：" prop="corporationIdCardUrlFront"  v-if="item.shareCredType === '00'" style="display: none;">
        <el-upload
          ref="idCardForm"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {frontHandleRemove(file)}"
          :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="办理人身份证反面照：" prop="corporationIdCardUrlBack"  v-if="item.shareCredType === '00'" style="display: none;">
        <el-upload
          ref="idCardForm"
          class="upload-demo"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
          :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="上传证件：" prop="backUrl" v-if="item.shareCredType !== '00'" style="display: none;">
        <el-upload
          ref="uploadPersonal"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
          :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="姓名：" prop="shareName">
        <el-input v-model="item.shareName" style="width:340px" />
      </el-form-item>
      <el-form-item label="证件类型：" prop="shareCredType">
        <el-select v-model="item.shareCredType" placeholder="请选择">
          <el-option
            v-for="item in shareCredTypelist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码：" prop="shareCredNo" style="width:540px">
        <el-input v-model="item.shareCredNo" />
      </el-form-item>
      <el-form-item label="证件有效期：">
        <div style="display: flex;align-items: center;width: 320px">
          <el-date-picker
            v-model="item.shareCredValidStart"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="开始时间">
          </el-date-picker>
          至
          <el-date-picker
            v-model="item.shareCredValidEnd"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="结束时间">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-divider />
    </el-form>
    <el-form v-for="(item, index) in beneficiaryList"  label-width="180px" :key="'list4-'+index">
      <div class="delet">
        <span>受益所有人：</span>
        <el-button class="add" type="primary"  v-if="index !== 0" @click="actuadeletInfo(item, index)" size="mini">删除</el-button>
      </div>
      <el-form-item label="受益人身份证正面照：" prop="corporationIdCardUrlFront"  v-if="item.shareCredType === '00'" style="display: none;">
        <el-upload
          ref="idCardForm"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {frontHandleRemove(file)}"
          :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="受益人身份证反面照：" prop="corporationIdCardUrlBack"  v-if="item.shareCredType === '00'" style="display: none;">
        <el-upload
          ref="idCardForm"
          class="upload-demo"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
          :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="上传证件：" prop="backUrl" v-if="item.shareCredType !== '00'" style="display: none;">
        <el-upload
          ref="uploadPersonal"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
          :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="姓名：" prop="shareName">
        <el-input v-model="item.shareName" style="width:340px" />
      </el-form-item>
      <el-form-item label="证件类型：" prop="shareCredType">
        <el-select v-model="item.shareCredType" placeholder="请选择">
          <el-option
            v-for="item in shareCredTypelist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码：" prop="shareCredNo" style="width:540px">
        <el-input v-model="item.shareCredNo" />
      </el-form-item>
      <el-form-item label="证件有效期：" prop="shareCredValidStart">
        <div style="display: flex;align-items: center;width: 320px">
          <el-date-picker
            v-model="item.shareCredValidStart"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="开始时间">
          </el-date-picker>
          至
          <el-date-picker
            v-model="item.shareCredValidEnd"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="结束时间">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="常住地（请精确到门牌号）：">
        <el-row>
          <div style="display: flex;" v-if="index === 0">
            <el-form-item prop="tradeLicenseProvince">
              <el-select v-model="item.shareProvinceName" placeholder="省" :clearable="true" style="width:110px;" @change="getCityData">
                <el-option
                  v-for="(item) in provinceArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="tradeLicenseCity">
              <el-select v-model="item.shareCityName" placeholder="市" :clearable="true" style="padding-left:5px;width:110px;" @change="getCountyData">
                <el-option
                  v-for="(item) in cityArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="tradeLicenseCountie">
              <el-select v-model="item.shareAreaName" placeholder="区/县" :clearable="true" style="padding-left:5px;width:110px;" @change="changeCountyData">
                <el-option
                  v-for="(item) in countyArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-top:10px">
            <el-form-item prop="shareStreet">
              <el-input v-model="item.shareStreet" style="margin-top: 10px;width:340px" placeholder="请输入详细地址(精确到门牌号)" />
            </el-form-item>
          </div>
        </el-row>
      </el-form-item>
    </el-form>
    <div v-if='addForm'>
      <div style="text-align: right;">
        <el-button type="primary" size="small" @click="deletInfo">删除</el-button>
      </div>
      <el-divider />
      <el-form ref="infoForm" :model="infoForm" label-width="180px">
        <el-form-item label="信息类型：">
          <el-select v-model="Information" placeholder="请选择" style="width:160px">
            <el-option
              v-for="item in identityType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form ref="infoFormFront" :model="infoForm" :rules="infogetFront" label-width="180px" v-if="Information == '00'">
          <el-form-item label="办理人身份证正面照：" prop="corporationIdCardUrlFront" v-if="infoForm.shareCredType === '00'">
            <el-upload
              ref="idCardForm"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {frontHandleRemove(file)}"
              :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="办理人身份证反面照：" prop="corporationIdCardUrlBack" v-if="infoForm.shareCredType === '00'">
            <el-upload
              ref="idCardForm"
              class="upload-demo"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
              :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="上传证件：" prop="backUrl" v-if="infoForm.shareCredType !== '00'" style="display: none;">
            <el-upload
              ref="uploadPersonal"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
              :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="控股股东人姓名：" prop="shareName">
            <el-input v-model="infoForm.shareName" style="width:340px" />
          </el-form-item>
          <el-form-item label="证件类型：" prop="shareCredType">
            <el-select v-model="infoForm.shareCredType" placeholder="请选择">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="shareCredNo" style="width:340px">
            <el-input v-model="infoForm.shareCredNo" />
          </el-form-item>
          <el-form-item label="证件有效期：">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="infoForm.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="开始时间">
              </el-date-picker>
              至
              <el-date-picker
                v-model="infoForm.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="结束时间">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <el-form ref="infoFormCard" :model="infoForm" :rules="infogetCard" label-width="180px" v-if="Information == '01'">
          <el-form-item label="办理人身份证正面照：" prop="corporationIdCardUrlFront" v-if="infoForm.shareCredType === '00'">
            <el-upload
              ref="idCardForm"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {frontHandleRemove(file)}"
              :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="办理人身份证反面照：" prop="corporationIdCardUrlBack" v-if="infoForm.shareCredType === '00'">
            <el-upload
            ref="idCardForm"
              class="upload-demo"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
              :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="上传证件：" prop="backUrl" v-if="infoForm.shareCredType !== '00'" style="display: none;">
            <el-upload
              ref="uploadPersonal"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
              :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="实际控制人姓名：" prop="shareName">
            <el-input v-model="infoForm.shareName" style="width:340px" />
          </el-form-item>
          <el-form-item label="证件类型：" prop="shareCredType">
            <el-select v-model="infoForm.shareCredType" placeholder="请选择">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="shareCredNo" style="width:340px">
            <el-input v-model="infoForm.shareCredNo" />
          </el-form-item>
          <el-form-item label="证件有效期：">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="infoForm.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="开始时间">
              </el-date-picker>
              至
              <el-date-picker
                v-model="infoForm.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="结束时间">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <el-form ref="infoForm" :model="infoForm" :rules="infogetlist" label-width="180px" v-if="Information == '02'">
          <el-form-item label="办理人身份证正面照：" prop="corporationIdCardUrlFront" v-if="infoForm.shareCredType === '00'">
            <el-upload
            ref="idCardForm"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {frontHandleRemove(file)}"
              :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="办理人身份证反面照：" prop="corporationIdCardUrlBack" v-if="infoForm.shareCredType === '00'">
            <el-upload
            ref="idCardForm"
              class="upload-demo"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
              :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="上传证件：" prop="backUrl" v-if="infoForm.shareCredType !== '00'" style="display: none;">
            <el-upload
              ref="uploadPersonal"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
              :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="授权办理人姓名：" prop="shareName">
            <el-input v-model="infoForm.shareName" style="width:340px" />
          </el-form-item>
          <el-form-item label="证件类型：" prop="shareCredType">
            <el-select v-model="infoForm.shareCredType" placeholder="请选择">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="shareCredNo" style="width:340px">
            <el-input v-model="infoForm.shareCredNo" />
          </el-form-item>
          <el-form-item label="证件有效期：">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="infoForm.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="开始时间">
              </el-date-picker>
              至
              <el-date-picker
                v-model="infoForm.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="结束时间">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <el-form ref="infoFormfromt" :model="infoForm" :rules="rules" label-width="180px" v-if="Information == '03'">
          <el-form-item label="受益人身份证正面照：" prop="corporationIdCardUrlFront" v-if="infoForm.shareCredType === '00'">
            <el-upload
              ref="idCardForm"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {frontHandleRemove(file)}"
              :http-request="(file) => {frontHandleUpload(file, 'corporationIdCardUrlFront')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="受益人身份证反面照：" prop="corporationIdCardUrlBack" v-if="infoForm.shareCredType === '00'">
            <el-upload
              ref="idCardForm"
              class="upload-demo"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {backHandleRemove(file, 'corporationIdCardUrlBack')}"
              :http-request="(file) => {backHandleUpload(file, 'corporationIdCardUrlBack')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="上传证件：" prop="backUrl" v-if="infoForm.shareCredType !== '00'" style="display: none;">
            <el-upload
              ref="uploadPersonal"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              list-type="picture-card"
              :on-remove="(file) => {licenseHandleRemove(file, 'backUrl')}"
              :http-request="(file) => {licenseHandleUpload(file, 'backUrl')}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="受益人姓名：" prop="shareName">
            <el-input v-model="infoForm.shareName" style="width:340px" />
          </el-form-item>
          <el-form-item label="证件类型：" prop="shareCredType">
            <el-select v-model="infoForm.shareCredType" placeholder="请选择">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="shareCredNo" style="width:340px">
            <el-input v-model="infoForm.shareCredNo" />
          </el-form-item>
          <el-form-item label="证件有效期：">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="infoForm.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="开始时间">
              </el-date-picker>
              至
              <el-date-picker
                v-model="infoForm.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="结束时间">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="常住地（请精确到门牌号）："  :required="true">
            <el-row>
              <div style="display: flex;">
                <el-form-item prop="tradeLicenseProvince">
                  <el-select v-model="infoForm.tradeLicenseProvince" placeholder="省" :clearable="true" style="width:110px;" @change="getCityData">
                    <el-option
                      v-for="(item) in provinceArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item prop="tradeLicenseCity">
                  <el-select v-model="infoForm.tradeLicenseCity" placeholder="市" :clearable="true" style="padding-left:5px;width:110px;" @change="getCountyData">
                    <el-option
                      v-for="(item) in cityArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item prop="tradeLicenseCountie">
                  <el-select v-model="infoForm.tradeLicenseCountie" placeholder="区/县" :clearable="true" style="padding-left:5px;width:110px;" @change="changeCountyData">
                    <el-option
                      v-for="(item) in countyArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div style="margin-top:10px">
                <el-form-item prop="shareStreet">
                  <el-input v-model="infoForm.shareStreet" style="margin-top: 10px;width:340px" placeholder="请输入详细地址(精确到门牌号)" />
                </el-form-item>
              </div>
            </el-row>
          </el-form-item>
        </el-form>
      </el-form>
    </div>
    <div style="text-align: center;">
      <el-button type="primary" @click="companyAuth">上一步</el-button>
      <el-button type="primary" @click="shareInfoUpdate">提交</el-button>
    </div>
  </div>
</template>

<script>
import { OCRIdCardFront, shareInfoSearch, shareInfoUpdate, customerUpdate } from '@/api/info'
import { setNull, getArea } from '@/api/common/common'
import File from '@/utils/file'
import store from '@/store'
import Session from '@/utils/session'
import { SelectCertificateOnClick, SignOnClick } from '@/utils/CryptoKit'

export default {
  data() {
    return {
      Information: null,
      addForm: false,
      // identityType 授权类型（00-控股股东，01-实际控制人，02-授权办理，03-最终受益人）
      identityType: [
        { value: '00', label: '控股股东人信息' },
        { value: '01', label: '实际控制人信息' },
        { value: '02', label: '授权办理人信息' },
        { value: '03', label: '受益人信息' }
      ],
      shareCredTypelist: [
        { value: '00', label: '身份证' },
        { value: '01', label: '护照' },
        { value: '02', label: '营业执照' },
        { value: '03', label: '其他' }
      ],
      infogetFront: {
        shareCredNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        shareName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        shareCredType: [
          { required: true, message: '请输入证件类型', trigger: 'blur' }
        ],
        shareCredValidStart: [
          { required: true, message: '请输入证件有效期', trigger: 'blur' }
        ]
      },
      infogetCard: {
        shareCredNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        shareName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        shareCredType: [
          { required: true, message: '请输入证件类型', trigger: 'blur' }
        ],
        shareCredValidStart: [
          { required: true, message: '请输入证件有效期', trigger: 'blur' }
        ]
      },
      infogetlist: {
        shareCredNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        shareName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        shareCredType: [
          { required: true, message: '请输入证件类型', trigger: 'blur' }
        ],
        shareCredValidStart: [
          { required: true, message: '请输入证件有效期', trigger: 'blur' }
        ]
      },
      rules: {
        shareCredNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        shareName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        shareCredType: [
          { required: true, message: '请输入证件类型', trigger: 'blur' }
        ],
        shareCredValidStart: [
          { required: true, message: '请输入证件有效期', trigger: 'blur' }
        ],
        shareStreet: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        shareCredValidEnd: [
          { required: true, message: '请输入证件有效期', trigger: 'blur' }
        ],
        tradeLicenseProvince: [
          { required: true, message: '请选择单位所在地省', trigger: 'change' }
        ],
        tradeLicenseCity: [
          { required: true, message: '请选择单位所在地市', trigger: 'change' }
        ],
        tradeLicenseCountie: [
          { required: true, message: '请选择单位所在县', trigger: 'change' }
        ]
      },
      // 授权类型（00-控股股东，01-实际控制人，02-授权办理，03-最终受益人）
      // 控股股东
      holdList: [],
      // 实际控制人
      actualList: [],
      // 授权办理人
      grantList: [],
      // 收益所有人
      beneficiaryList: [],
      infoForm: {
        // 客户id
        customerId: Session.getItem('customerId'),
        // 身份证
        shareCredNo: null,
        certPicUrl: null,
        certBackPicUrl: null,
        shareCredValidStart: null,
        shareCredValidEnd: null,
        shareCredType: null,
        shareCred: null,
        createStart: '',
        createStartTime: '',
        grantStartTime: '',
        actuaStartTime: '',
        shareName: null,
        editFlag: 1,
        isOverDue: true,
        // 企业名称
        companyName: null,
        // 企业类型  0个体 1企业
        enterpriseType: null,
        // 社会信用代码证
        tradeLicenseNo: null,
        // 营业执照所在省
        tradeLicenseProvince: null,
        // 营业执照所在市
        tradeLicenseCity: null,
        // 营业执照所在地区县
        tradeLicenseCountie: null,
        // 营业执照所在省编码
        tradeLicenseProvinceNo: null,
        // 营业执照所在市编码
        tradeLicenseCityNo: null,
        // 营业执照所在地区县编码
        tradeLicenseCountieNo: null,
        // 详细地址
        shareStreet: null,
        // 成立日期
        openDate: null,
        // 经营时限开始
        businessTermFrom: null,
        // 经营时限结束
        businessTermTo: null,
        // 经营期限至-长期标志 1：长期；0：非长期
        businessTermValid: null,
        // 营业执照文件存放code
        tradeLicenseUrl: null,
        // 法人姓名
        corporationName: null,
        // 法人证件号
        corporationIdCardNo: null,
        // 法人证件类型 1：身份证；2：其他
        corporationIdCardType: '1',
        // 身份证正面
        corporationIdCardUrlFront: null,
        // 身份证反面
        corporationIdCardUrlBack: null,
        // 联系人姓名
        contactName: null,
        // 联系人手机号
        contactPhone: Session.getItem('phone'),
        // 	是否跨境 0-非跨境 1-跨境
        crossBorderFlag: '0',
        // 币种
        ccy: 'CNY',
        // 操作人
        openUserId: Session.getItem('phone')
      },
      sourceData: {},
      // 省
      provinceArray: [],
      cityArray: [],
      countyArray: [],
      fileList: [],
      grantid: [],
      actual: [],
      grant: [],
      beneficiaryid: [],
      arr: '',
      personalInfoForm: {
        customerId: store.getters.customerId,
        corporationIdCardUrlFront: null,
        corporationIdCardUrlBack: null,
        editFlag: 1,
        isOverDue: true,
        // 营业执照
        backUrl: null
      },
      perFormancet: {}
    }
  },
  created() {
    this.getArea()
    this.InfoSearch()
  },
  mounted() {
  },
  methods: {
    deletInfo() {
      this.addForm = false
    },
    add() {
      this.addForm = true
    },
    grantdeletInfo(item, index) {
      this.arr = this.arr + item.id + ','
      this.grantList.splice(index, 1)
    },
    actuadeletInfo(item, index) {
      this.arr = this.arr + item.id + ','
      this.beneficiaryList.splice(index, 1)
    },
    actualdeletInfo(item, index) {
      this.arr = this.arr + item.id + ','
      this.actualList.splice(index, 1)
    },
    holdListdeletInfo(item, index) {
      this.arr = this.arr + item.id + ','
      this.holdList.splice(index, 1)
    },
    suBmitPersonal() {
      const param = setNull(this.personalInfoForm)
      customerUpdate(param).then(res => {
        this.$message.success(res.message)
      }).catch(error => {
        this.$message.error(error)
      })
    },
    sdeaddinfo() {
      if (this.Information === '00') {
        this.holdList.map(item => {
          if (item.id === this.perFormancet.id) {
            this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
            this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
            this.perFormancet.backUrl = this.personalInfoForm.backUrl
          }
        })
        const summaryArr = {
          identityType: '00',
          shareName: this.infoForm.shareName,
          shareCredType: this.infoForm.shareCredType,
          shareCredNo: this.infoForm.shareCredNo,
          certPicUrl: this.perFormancet.certPicUrl,
          backUrl: this.perFormancet.backUrl,
          certBackPicUrl: this.perFormancet.certBackPicUrl,
          shareCredValidStart: this.infoForm.shareCredValidStart,
          shareCredValidEnd: this.infoForm.shareCredValidEnd
        }
        this.holdList.push(summaryArr)
      }
      if (this.Information === '01') {
        this.actualList.map(item => {
          if (item.id === this.perFormancet.id) {
            this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
            this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
            this.perFormancet.backUrl = this.personalInfoForm.backUrl
          }
        })
        const summaryArr = {
          identityType: '01',
          shareName: this.infoForm.shareName,
          shareCredType: this.infoForm.shareCredType,
          shareCredNo: this.infoForm.shareCredNo,
          certPicUrl: this.perFormancet.certPicUrl,
          backUrl: this.perFormancet.backUrl,
          certBackPicUrl: this.perFormancet.certBackPicUrl,
          shareCredValidStart: this.infoForm.shareCredValidStart,
          shareCredValidEnd: this.infoForm.shareCredValidEnd
        }
        this.actualList.push(summaryArr)
      }
      if (this.Information === '02') {
        this.grantList.map(item => {
          if (item.id === this.perFormancet.id) {
            this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
            this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
            this.perFormancet.backUrl = this.personalInfoForm.backUrl
          }
        })
        const summaryArr = {
          identityType: '02',
          shareName: this.infoForm.shareName,
          shareCredType: this.infoForm.shareCredType,
          shareCredNo: this.infoForm.shareCredNo,
          certPicUrl: this.perFormancet.certPicUrl,
          backUrl: this.perFormancet.backUrl,
          certBackPicUrl: this.perFormancet.certBackPicUrl,
          shareCredValidStart: this.infoForm.shareCredValidStart,
          shareCredValidEnd: this.infoForm.shareCredValidEnd
        }
        this.grantList.push(summaryArr)
      }
      if (this.Information === '03') {
        this.beneficiaryList.map(item => {
          if (item.id === this.perFormancet.id) {
            this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
            this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
            this.perFormancet.backUrl = this.personalInfoForm.backUrl
          }
        })
        const summaryArr = {
          identityType: '03',
          shareName: this.infoForm.shareName,
          shareCredType: this.infoForm.shareCredType,
          shareCredNo: this.infoForm.shareCredNo,
          certPicUrl: this.perFormancet.certPicUrl,
          backUrl: this.perFormancet.backUrl,
          certBackPicUrl: this.perFormancet.certBackPicUrl,
          shareCredValidStart: this.infoForm.shareCredValidStart,
          shareCredValidEnd: this.infoForm.shareCredValidEnd,
          shareProvinceId: this.infoForm.tradeLicenseProvinceNo,
          shareProvinceName: this.infoForm.tradeLicenseProvince,
          shareCityId: this.infoForm.tradeLicenseCountieNo,
          shareCityName: this.infoForm.tradeLicenseCity,
          shareAreaId: this.infoForm.tradeLicenseCityNo,
          shareAreaName: this.infoForm.tradeLicenseCountie,
          shareStreet: this.infoForm.shareStreet
        }
        this.beneficiaryList.push(summaryArr)
      }
    },
    InfoSearch() {
      const param = {
        customerId: this.infoForm.customerId
      }
      shareInfoSearch(param).then((res, index) => {
        this.actualList = res.data.actualList
        this.beneficiaryList = res.data.beneficiaryList
        this.grantList = res.data.grantList
        this.holdList = res.data.holdList
        // 证件有效期
        this.beneficiaryList.map(item => {
          this.perFormancet = item
          console.log(item, 'beneficiaryList')
          if (item.shareCredValidStart == null && item.shareCredValidEnd == null) {
            this.$set(this.infoForm, 'createStartTime', ['', ''])
          } else {
            this.$set(this.infoForm, 'createStartTime', [item.shareCredValidStart, item.shareCredValidEnd])
          }
        })
        this.holdList.map(item => {
          this.perFormancet = item
          console.log(item, 'holdList')
          if (item.shareCredValidStart == null && item.shareCredValidEnd == null) {
            this.$set(this.infoForm, 'createStart', ['', ''])
          } else {
            this.$set(this.infoForm, 'createStart', [item.shareCredValidStart, item.shareCredValidEnd])
          }
        })
        this.grantList.map(item => {
          this.perFormancet = item
          console.log(item, 'grantList')
          if (item.shareCredValidStart == null && item.shareCredValidEnd == null) {
            this.$set(this.infoForm, 'grantStartTime', ['', ''])
          } else {
            this.$set(this.infoForm, 'grantStartTime', [item.shareCredValidStart, item.shareCredValidEnd])
          }
        })
        this.actualList.map(item => {
          this.perFormancet = item
          console.log(item, 'actualList')
          if (item.shareCredValidStart == null && item.shareCredValidEnd == null) {
            this.$set(this.infoForm, 'actuaStartTime', ['', ''])
          } else {
            this.$set(this.infoForm, 'actuaStartTime', [item.shareCredValidStart, item.shareCredValidEnd])
          }
        })
      }).catch(error => {
        console.log(error) // 捕获异常
      })
    },
    shareInfopdateaa() {
      this.beneficiaryList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      this.grantList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      this.actualList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      this.holdList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      // new Promise((resolve, reject) => {
      //   if (this.Information === '00') {
      //     this.$refs['infoFormFront'].validate(valid => {
      //       if (valid) {
      //         this.allpromst()
      //         resolve()
      //       } else {
      //         return false
      //       }
      //     })
      //   } else if (this.Information === '01') {
      //     this.$refs['infoFormCard'].validate(valid => {
      //       if (valid) {
      //         this.allpromst()
      //         resolve()
      //       } else {
      //         return false
      //       }
      //     })
      //   } else if (this.Information === '02') {
      //     this.$refs['infoForm'].validate(valid => {
      //       if (valid) {
      //         this.allpromst()
      //         resolve()
      //       } else {
      //         return false
      //       }
      //     })
      //   } else if (this.Information === '03') {
      //     this.$refs['infoFormfromt'].validate(valid => {
      //       if (valid) {
      //         this.allpromst()
      //         resolve()
      //       } else {
      //         return false
      //       }
      //     })
      //   } else {
      //     this.allpromst()
      //   }
      // })
    },
    // 提交
    shareInfoUpdate() {
      this.holdList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      this.grantList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      this.actualList.map(item => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
      })
      this.beneficiaryList.map((item, index) => {
        if (item.id === this.perFormancet.id) {
          this.perFormancet.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.perFormancet.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.perFormancet.backUrl = this.personalInfoForm.backUrl
        }
        if (this.infoForm.tradeLicenseProvince !== null) {
          item.identityType = '03'
          item.shareProvinceId = this.infoForm.tradeLicenseProvinceNo
          item.shareProvinceName = this.infoForm.tradeLicenseProvince
          item.shareCityId = this.infoForm.tradeLicenseCityNo
          item.shareCityName = this.infoForm.tradeLicenseCity
          item.shareAreaId = this.infoForm.tradeLicenseCountieNo
          item.shareAreaName = this.infoForm.tradeLicenseCountie
        }
      })
      this.sdeaddinfo()
      const param = {
        customerId: this.infoForm.customerId,
        deleteIds: this.arr,
        isEdit: 0,
        editFlag: 1,
        isOverDue: true,
        companyFxqShareInfoUpdateListReqList: JSON.parse(JSON.stringify(this.actualList.concat(this.beneficiaryList).concat(this.holdList).concat(this.grantList)))
      }
      const signKeys = ['shareName', 'shareCredNo']
      param.isCfcaDecrypt = SelectCertificateOnClick()
      for (const item of signKeys) {
        for (let i = 0; i < param.companyFxqShareInfoUpdateListReqList.length; i++) {
          if (param.companyFxqShareInfoUpdateListReqList[i][item]) {
            param.companyFxqShareInfoUpdateListReqList[i][item] = SignOnClick(param.companyFxqShareInfoUpdateListReqList[i][item]).result
          }
        }
      }
      shareInfoUpdate(param).then(res => {
        this.addForm = false
        this.$message.success(res.message)
      }).catch(error => {
        this.addForm = false
        this.$message.error(error)
      })
    },
    // 获取省
    getArea() {
      const param = {}
      getArea(param)
        .then(res => {
          this.provinceArray = res.data.children
        })
        .catch(error => {
          // 捕获异常
          console.log(error)
        })
    },
    // 注册地址市
    getCityData(val) {
      this.cityArray = []
      this.countyArray = []
      this.infoForm.tradeLicenseCity = null
      this.infoForm.tradeLicenseCityNo = null
      this.infoForm.tradeLicenseCountie = null
      this.infoForm.tradeLicenseCountieNo = null
      this.infoForm.tradeLicenseProvinceNo = val
      for (const item of this.provinceArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseProvince = item.name
          console.log(this.infoForm.tradeLicenseProvince, 'this.infoForm.tradeLicenseProvince')
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param).then(res => {
            this.cityArray = res.data.children
            resolve(this.cityArray)
          }).catch(error => {
            reject(error)
            console.log(error) // 捕获异常
          })
        })
      }
    },
    // 注册县
    getCountyData(val) {
      this.countyArray = []
      this.infoForm.tradeLicenseCountie = null
      this.infoForm.tradeLicenseCountieNo = null
      this.infoForm.tradeLicenseCityNo = val
      for (const item of this.cityArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseCity = item.name
          console.log(this.infoForm.tradeLicenseCity, 'this.infoForm.tradeLicenseCity')
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.countyArray = res.data.children
              resolve(this.countyArray)
            })
            .catch(error => {
              console.log(error) // 捕获异常
              reject(error)
            })
        })
      }
    },
    // 注册区事件
    changeCountyData(val) {
      this.infoForm.tradeLicenseCountieNo = val
      for (const item of this.countyArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseCountie = item.name
        }
      }
    },
    companyAuth() {
      this.$router.push({
        name: 'companyAuth'
      })
    },
    // 图片删除事件
    backHandleRemove(file, key) {
      this.infoForm[key] = null
    },
    // ocr识别身份证
    OCRIdCardFront(url) {
      const param = {
        orderNo: this.uuid(),
        source: '客户-企业认证',
        ocrImg: url
      }
      OCRIdCardFront(param)
        .then(res => {
          const { name, idCard } = res.data.data
          this.infoForm.corporationName = name
          this.infoForm.corporationIdCardNo = idCard
          Object.assign(this.sourceData, {
            corporationName: name,
            corporationIdCardNo: idCard
          })
          this.$refs['form'].clearValidate(['corporationName', 'corporationIdCardNo'])
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 图片删除事件
    licenseHandleRemove(file) {
      this.personalInfoForm.backUrl = null
    },
    // 上传营业执照
    licenseHandleUpload(data) {
      const file = data.file
      const form = new FormData()
      form.append('file', file)
      File.upload(form)
        .then(response => {
          console.log(response.data.code, '上传营业执照')
          this.personalInfoForm.backUrl = response.data.code
          // this.getBese64(file, this.OCRBslIC)
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 上传身份证正面图片
    frontHandleUpload(data, key) {
      const file = data.file
      const form = new FormData()
      form.append('file', file)
      File.upload(form)
        .then(response => {
          this.personalInfoForm.corporationIdCardUrlFront = response.data.code
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 上传身份证反面图片
    backHandleUpload(data, key) {
      const file = data.file
      const form = new FormData()
      form.append('file', file)
      File.upload(form)
        .then(response => {
          this.personalInfoForm.corporationIdCardUrlBack = response.data.code
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>

<style scoped>
.delet{
  display: flex;
  justify-content: space-between
}
</style>

